import React from 'react';
import ExemptionList from './ExemptionList';
import AddToExemptionsButton from '../Utilities/AddToThrottleExemptions/AddToExemptionsButton';
import { Card } from 'antd';
import QuickAddExemption from './QuickAddExemptions';
import useCheckPermissions from 'hooks/auth/useCheckPermission';

const ThrottleExemption = () => {
  const { userCheckPermission } = useCheckPermissions();

  const canAdd = userCheckPermission('user.view');

  return (
    <div>
      {canAdd && (
        <Card>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <div>
              <AddToExemptionsButton />
            </div>
            <div>
              <QuickAddExemption />
            </div>
          </div>
        </Card>
      )}
      <ExemptionList />
    </div>
  );
};

export default ThrottleExemption;
